import { supabase } from '../config/supabase'

/**
 * Fetch reschedule policy (single global row).
 * Returns policy object with fee, cutoff and max-reschedule settings.
 */
export const getReschedulePolicy = async () => {
  try {
    // Use maybeSingle() — returns null (no error) when 0 rows, avoids PGRST116
    const { getSelectedSalonId } = await import('../utils/salonScope')
    const salonId = getSelectedSalonId()
    let query = supabase
      .from('reschedule_policies')
      .select(
        'fee_policy_enabled, fee_window_hours, fee_percentage, cutoff_policy_enabled, cutoff_hours_before, max_reschedules_enabled, max_reschedules'
      )
    if (salonId) {
      query = query.eq('salon_id', salonId)
    }
    const { data, error } = await query.limit(1).maybeSingle()

    if (error) {
      console.error('❌ Error fetching reschedule policy:', error)
      return null
    }

    if (!data) {
      console.warn('ℹ️ No reschedule policy row found in DB')
      return null
    }

    return {
      feePolicyEnabled: !!data.fee_policy_enabled,
      // Use Number() to safely handle both integer and string returns from Supabase
      feeWindowHours: data.fee_window_hours != null ? Number(data.fee_window_hours) : null,
      feePercentage: data.fee_percentage != null ? Number(data.fee_percentage) : null,
      cutoffPolicyEnabled: !!data.cutoff_policy_enabled,
      cutoffHoursBefore: data.cutoff_hours_before != null ? Number(data.cutoff_hours_before) : null,
      maxReschedulesEnabled: !!data.max_reschedules_enabled,
      maxReschedules: data.max_reschedules != null ? Number(data.max_reschedules) : null,
    }
  } catch (error) {
    console.error('❌ Exception in getReschedulePolicy:', error)
    return null
  }
}

